import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateMembershipPlan = props => {
  return (
    <Create
// @ts-ignore
      title='Create Membership Plan'
      fields={fields}
      apiPath='admin/membership_plans'
      successRedirectPath={resource => `/membership/membership-plans/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateMembershipPlan
